import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import React from "react";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { useWindowDimensions } from "../WindowDimensionsProvider";
import "./style.css";

const fm = getFormattedMessageWithScope("components.Tabs");

interface TabsProps {
    items: {
        title: string | JSX.Element;
        onClick: any;
        active: boolean;
        disabled?: boolean;
        current: boolean;
    }[];
    disabled?: boolean;
}

export const Tabs = ({ items, disabled }: TabsProps) => {
    const { width } = useWindowDimensions();

    function renderTabs() {
        return items.map((item, index) => (
            <React.Fragment key={index}>
                <div
                    className={classnames(
                        "c-Tabs-tab",
                        items.length === 2
                            ? "c-Tabs-tab-2tabs"
                            : "c-Tabs-tab-3tabs",
                        item.active ? "c-Tabs-tab-active" : undefined,
                        item.current ? "c-Tabs-tab-current" : undefined,
                        item.active && index !== items.length - 1
                            ? "c-Tabs-tab-active-progressive"
                            : undefined,
                        disabled || item.disabled
                            ? "c-Tabs-tab-disabled"
                            : undefined
                    )}
                    onClick={
                        !disabled && !item.disabled ? item.onClick : undefined
                    }
                >
                    <span className="c-Tabs-tab-title">
                        {item.current && width <= 600
                            ? fm({ id: "step", values: { number: index + 1 } })
                            : item.title}
                    </span>
                </div>
                {index !== items.length - 1 && (
                    <FontAwesomeIcon
                        icon={faChevronRight as IconProp}
                        className="c-Tabs-tab-arrow-right"
                    />
                )}
            </React.Fragment>
        ));
    }

    return <div className="c-Tabs-container">{renderTabs()}</div>;
};
